import request from '@/utils/request'


// 查询用户报备列表
export function listReport(query) {
  return request({
    url: '/user/user-report/list',
    method: 'get',
    params: query
  })
}

// 查询用户报备分页
export function pageReport(query) {
  return request({
    url: '/user/user-report/page',
    method: 'get',
    params: query
  })
}

// 查询用户报备详细
export function getReport(data) {
  return request({
    url: '/user/user-report/detail',
    method: 'get',
    params: data
  })
}

// 新增用户报备
export function addReport(data) {
  return request({
    url: '/user/user-report/add',
    method: 'post',
    data: data
  })
}

// 修改用户报备
export function updateReport(data) {
  return request({
    url: '/user/user-report/edit',
    method: 'post',
    data: data
  })
}

// 删除用户报备
export function delReport(data) {
  return request({
    url: '/user/user-report/delete',
    method: 'post',
    data: data
  })
}
